export default
function createImageUrl(image, size = 100) {
  if (!image || !('url' in image)) {
    return ''
  }

  return `${window.APP_CONFIG.API_HOST.replace(/https?:/, '')}/data/${image.url.replace(
    /\/([^/]+)(\.(?:jpg|png))$/,
    `/${size}_$1.jpg`
    // turn anything into a jpg, as we do that on the server as well!
    // (see /Users/simonschmidt/Sites/musbi/api/app/services/ImageResizer.php:34)
  )}`
}



// WEBPACK FOOTER //
// ./src/frontend/shared/createImageUrl.js